import {useDispatch, useSelector} from "react-redux";
import logo from '../images/logo.svg'
import {mobile_filter, mobile_guides, mobile_menu, signin_click, signup_click} from "../redux/actions";
import React, {useEffect} from 'react';


export const Header = () => {
    const scroll_const = 65;
    const dispatch = useDispatch()
    const airconfig = useSelector(state => state.app.airconfig)
    const app_lang = useSelector(state => state.app.app_lang)
    const isMobile = useSelector(state => state.app.isMobile)
    const mobileMenu = useSelector(state => state.app.mobileMenu)
    const mobileFilter = useSelector(state => state.app.mobileFilter)
    const mobileGuides = useSelector(state => state.app.mobileGuides)
    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY > scroll_const) {
                let elems = document.querySelectorAll(".site-header2");
                [].forEach.call(elems, function (el) {
                    el.classList.add("fixed");
                });
            } else {
                let elems = document.querySelectorAll(".site-header2");
                [].forEach.call(elems, function (el) {
                    el.classList.remove("fixed");
                });
            }
        });
    }, []);

    const handleBurgerClick = (checked) => {
        dispatch(mobile_menu(checked))
        if (checked === true) {
            dispatch(mobile_filter(checked))
        }
    }
    const handleGuidesClick = (e, checked) => {
        dispatch(mobile_guides(checked))
        return false;
    }
    const has_childs = (airconfig, index) => {
        let r = false;
        for (let i = 0; i < airconfig.length; i++) {
            if (airconfig[i].fields.type === 'header_sub_menu' && airconfig[i].fields.locale === app_lang) {
                if (airconfig[i].fields.id.indexOf('header_menu_item_' + index + '_') >= 0) {
                    r = true;
                }
            }
        }
        return r;
    }
    if (mobileMenu) {
        document.body.style.overflow = "hidden"
    } else {
        document.body.style.overflow = "auto"
    }
    if (airconfig.length > 0) {
        //if (isMobile && mobileMenu)
        return (
            <React.Fragment>
                <header className="site-header container">
                    <div className="container__wrap site-header__flex">
                        {
                            airconfig.map((item) => {
                                if (item.fields.id === 'logo' && item.fields.locale === app_lang) {
                                    return (
                                        <a href={item.fields.link} key={item.fields.id} className="site-header__logo"
                                           target="_blank" rel="noopener">
                                            <img src={logo} alt={item.fields.label} title={item.fields.label}/>
                                        </a>
                                    )
                                }
                                return null;
                            })
                        }
                        {
                            !isMobile && (
                                <nav className="site-header__menu" id="site-header__menu">
                                    <ul id="menu-header" className="menu">
                                        {

                                            airconfig.map((item, index) => {
                                                if (item.fields.type === 'header_menu' && item.fields.locale === app_lang) {
                                                    let menu_index = item.fields.id.toString().replace('header_menu_item_','');
                                                    let className = '';
                                                    if (has_childs(airconfig, menu_index)) {
                                                        className = 'menu-item-has-children '+app_lang;
                                                    }
                                                    if (item.fields.class !== undefined) {
                                                        className += ' ' + item.fields.class;
                                                    }
                                                    return (
                                                        <li key={item.fields.id} className={className}>
                                                            <a href={item.fields.link} target="_blank" rel="noopener">
                                                                {item.fields.label}
                                                            </a>
                                                            {
                                                                has_childs(airconfig, menu_index) && (
                                                                    <ul>
                                                                        {
                                                                            airconfig.map((s_item, s_index) => {
                                                                                if (s_item.fields.type === 'header_sub_menu' && s_item.fields.locale === app_lang) {
                                                                                    if (s_item.fields.id.indexOf('header_menu_item_' + menu_index + '_') >= 0) {
                                                                                        if (s_item.fields.label === 'line') {
                                                                                            return (
                                                                                                <li key={s_item.fields.id}>
                                                                                                        <span
                                                                                                            className="line"/>
                                                                                                </li>
                                                                                            )
                                                                                        }
                                                                                        if (s_item.fields.label === 'Guides') {
                                                                                            return (
                                                                                                <li key={s_item.fields.id}
                                                                                                    className={s_item.fields.id + ' menu-item-has-children'}>
                                                                                                    <a href={s_item.fields.link}
                                                                                                       className={s_item.fields.class !== undefined ? s_item.fields.class : ''}
                                                                                                       target="_blank"
                                                                                                       rel="noopener">
                                                                                                        <span></span>
                                                                                                        {s_item.fields.label}
                                                                                                    </a>
                                                                                                    <ul>
                                                                                                        {
                                                                                                            airconfig.map((g_item, g_index) => {
                                                                                                                if (g_item.fields.type === 'guides' && g_item.fields.locale === app_lang) {
                                                                                                                    return (
                                                                                                                        <li
                                                                                                                            className="guides"
                                                                                                                            key={g_index}
                                                                                                                        >
                                                                                                                            <a href={g_item.fields.link}
                                                                                                                               className="menu-link">
                                                                                                                                {g_item.fields.label}
                                                                                                                                <span>download guide</span>
                                                                                                                            </a>
                                                                                                                        </li>
                                                                                                                    )
                                                                                                                }
                                                                                                                return null;
                                                                                                            })
                                                                                                        }
                                                                                                    </ul>
                                                                                                </li>
                                                                                            )
                                                                                        }

                                                                                        return (
                                                                                            <li key={s_item.fields.id}
                                                                                                className={s_item.fields.id}>
                                                                                                <a href={s_item.fields.link}
                                                                                                   className={s_item.fields.class !== undefined ? s_item.fields.class : ''}
                                                                                                   target="_blank"
                                                                                                   rel="noopener">
                                                                                                    <span></span>
                                                                                                    {s_item.fields.label}
                                                                                                </a>
                                                                                            </li>
                                                                                        )
                                                                                    }
                                                                                }
                                                                                return null
                                                                            })
                                                                        }
                                                                    </ul>

                                                                )
                                                            }

                                                        </li>
                                                    )
                                                }
                                                return null;
                                            })
                                        }
                                    </ul>
                                </nav>
                            )
                        }
                        {
                            !isMobile && (
                                <React.Fragment>
                                    {
                                        airconfig.map((item) => {
                                            if (item.fields.id === 'header_sign_in' && item.fields.locale === app_lang) {
                                                return (
                                                    <a href={item.fields.link} key={item.fields.id}
                                                       onClick={() => signin_click()}
                                                       className="site-header__btn1 btn" target="_blank" rel="noopener">
                                                        {item.fields.label}
                                                    </a>
                                                )
                                            }
                                            return null;
                                        })
                                    }
                                    {
                                        airconfig.map((item) => {
                                            if (item.fields.id === 'header_sign_up' && item.fields.locale === app_lang) {
                                                return (
                                                    <a href={item.fields.link} key={item.fields.id}
                                                       onClick={() => signup_click('header', null, null)}
                                                       className="site-header__btn2 btn blue" target="_blank"
                                                       rel="noopener">
                                                        {item.fields.label}
                                                    </a>
                                                )
                                            }
                                            return null;
                                        })
                                    }

                                </React.Fragment>
                            )
                        }
                        {
                            isMobile && !mobileMenu && !mobileFilter && (
                                <div className="site-header__burger" onClick={() => handleBurgerClick(false)}/>)
                        }
                        {
                            isMobile && (mobileMenu || mobileFilter) && (
                                <div className="site-header__burger_close" onClick={() => handleBurgerClick(true)}/>)
                        }
                    </div>
                </header>
                {
                    isMobile && mobileMenu && (
                        <div className="mobile-menu container">
                            <div className="mobile-menu__box container__wrap">
                                <nav className="mobile-menu__nav mobile-menu__nav_1">
                                    <ul>
                                        {

                                            airconfig.map((item, index) => {
                                                if (item.fields.type === 'mobile_menu' && item.fields.locale === app_lang) {
                                                    return (
                                                        <li key={item.fields.id}>
                                                            <a href={item.fields.link}
                                                               className={item.fields.class !== undefined ? item.fields.class : ''}
                                                               target="_blank" rel="noopener">
                                                                {item.fields.label}
                                                            </a>
                                                        </li>
                                                    )
                                                }
                                                return null;
                                            })
                                        }
                                    </ul>
                                </nav>
                                <nav className="mobile-menu__nav mobile-menu__nav_2">
                                    <div className="mobile-menu__nav_heading">Resources</div>
                                    <ul>
                                        {

                                            airconfig.map((item, index) => {
                                                if (item.fields.type === 'mobile_r_menu' && item.fields.locale === app_lang) {
                                                    if (item.fields.label === 'Guides') {
                                                        return (
                                                            <li key={item.fields.id}
                                                                className={mobileGuides === true ? 'active' : ''}>
                                                                <span href={item.fields.link}
                                                                      className={item.fields.class !== undefined ? item.fields.class : ''}
                                                                      onClick={(e) => handleGuidesClick(e.target, mobileGuides)}
                                                                      target="_blank" rel="noopener">
                                                                    {item.fields.label}
                                                                </span>
                                                                <ul>
                                                                    {
                                                                        airconfig.map((s_item, s_index) => {
                                                                            if (s_item.fields.type === 'guides' && s_item.fields.locale === app_lang) {
                                                                                return (
                                                                                    <li
                                                                                        key={s_index}
                                                                                        className="guides">
                                                                                        <a href={s_item.fields.link}
                                                                                           className="menu-link">
                                                                                            {s_item.fields.label}
                                                                                            <span>download guide</span>
                                                                                        </a>
                                                                                    </li>
                                                                                )
                                                                            }
                                                                            return null;
                                                                        })
                                                                    }
                                                                </ul>
                                                            </li>
                                                        )
                                                    }
                                                    return (
                                                        <li key={item.fields.id}>
                                                            <a href={item.fields.link}
                                                               className={item.fields.class !== undefined ? item.fields.class : ''}
                                                               target="_blank" rel="noopener">
                                                                {item.fields.label}
                                                            </a>
                                                        </li>
                                                    )
                                                }
                                                return null;
                                            })
                                        }
                                    </ul>
                                </nav>
                                <nav className="mobile-menu__nav mobile-menu__nav_3">
                                    <div className="mobile-menu__nav_heading">Tools</div>
                                    <ul>
                                        {

                                            airconfig.map((item, index) => {
                                                if (item.fields.type === 'mobile_t_menu' && item.fields.locale === app_lang) {
                                                    return (
                                                        <li key={item.fields.id} >
                                                            <a href={item.fields.link}
                                                               className={item.fields.class !== undefined ? item.fields.class : ''}
                                                               target="_blank" rel="noopener">
                                                                {item.fields.label}
                                                            </a>
                                                        </li>
                                                    )
                                                }
                                                return null;
                                            })
                                        }
                                    </ul>
                                </nav>
                                {
                                    airconfig.map((item) => {
                                        if (item.fields.id === 'header_sign_in' && item.fields.locale === app_lang) {
                                            return (
                                                <a href={item.fields.link} key={item.fields.id}
                                                   onClick={() => signin_click()}
                                                   className="mobile-menu__btn_1" target="_blank" rel="noopener">
                                                    {item.fields.label}
                                                </a>
                                            )
                                        }
                                        return null;
                                    })
                                }
                                {
                                    airconfig.map((item) => {
                                        if (item.fields.id === 'header_sign_up' && item.fields.locale === app_lang) {
                                            return (
                                                <a href={item.fields.link} key={item.fields.id}
                                                   onClick={() => signup_click('header', null, null)}
                                                   className="mobile-menu__btn_2" target="_blank"
                                                   rel="noopener">
                                                    {item.fields.label}
                                                </a>
                                            )
                                        }
                                        return null;
                                    })
                                }
                            </div>
                        </div>
                    )
                }
            </React.Fragment>
        )
    }
    return null;
}